import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDividerModule} from '@angular/material/divider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatListModule} from '@angular/material/list';
import {MatTableModule} from '@angular/material/table';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTreeModule} from '@angular/material/tree';
// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuard } from 'app/auth/auth.guard';
import { SurveyStatusComponent } from './survey-status.component';
import {SurveyDialog,EmailAction_Dialog, SurveyCheckComponent,FechaProrrogaComponent, DialogInfo,DateMessageComponent} from './survey-status.component';
// import {AddUserDialog} from './survey-status.component';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';

import { NuevoColaboradorModule } from "./nuevo-colaborador/nuevo-colaborador.module";


import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
const rutas: Routes = [
  {
    path     : 'companies/survey-status-2/:id',
    component: SurveyStatusComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [SurveyStatusComponent,SurveyDialog,EmailAction_Dialog, SurveyCheckComponent,FechaProrrogaComponent,DialogInfo,DateMessageComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FlexLayoutModule,
    TranslateModule,
    MatStepperModule,
    MatFormFieldModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatTableModule,
    MatExpansionModule,
    MatTreeModule,
    MatCardModule,
    MatDialogModule,
    MatDatepickerModule,
    MatSelectModule,
    NuevoColaboradorModule,
    MatPaginatorModule,
    MatSortModule,
    NgxMaterialTimepickerModule,
  ],entryComponents:[
    SurveyDialog,
    EmailAction_Dialog,
    SurveyCheckComponent,
    FechaProrrogaComponent,
    DateMessageComponent,
    DialogInfo,
  ]
})
export class SurveyStatusModule { }
